import { Union, Literal } from "runtypes";
import type { Static } from "runtypes";

export const ScoreType = Union(
  Literal("market"),
  Literal("product"),
  Literal("financials"),
  Literal("management"),
  Literal("traction"),
  Literal("moat"),
  Literal("potential")
);

export type ScoreType = Static<typeof ScoreType>;
